module.exports = __webpack_public_path__ + "static/media/unionpay.e71100f4.png";